import { Component, OnInit, ViewChild } from '@angular/core';
import { MedicineGroupService } from "../../../../services/medicine-group.service";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalService } from "../../../../services/global.service";
import swal from 'sweetalert2'
import { MatTableDataSource, MatSort, MatPaginator } from "@angular/material";
@Component({
  selector: 'app-setting-medicine-group',
  templateUrl: './setting-medicine-group.component.html',
  styleUrls: ['./setting-medicine-group.component.scss']
})
export class SettingMedicineGroupComponent implements OnInit {
  medicine_groups: MatTableDataSource<any>;
  medicinesGroupForm: FormGroup;
  filtersForm: FormGroup;
  submitted = false;

  displayedColumns: string[] = ['index', 'name', 'description', 'action']
  @ViewChild(MatSort) sort: MatSort
  @ViewChild(MatPaginator) paginator: MatPaginator
  constructor(
    private MedicineGroupService: MedicineGroupService,
    private formBuilder: FormBuilder,
    private Global: GlobalService
  ) { }

  ngOnInit() {
    this.getMedicineGroups()
    this.setFiltersForm()
    this.setForm()
  }

  setFiltersForm() {
    this.filtersForm = this.formBuilder.group({
      keywords: ''
    });
  }

  setForm() {
    this.medicinesGroupForm = this.formBuilder.group({
      name: ['', Validators.required],
      description: '',
    });
  }

  showForm(medicine_groups = null) {
    this.submitted = false;
    if (medicine_groups != null) {
      this.medicinesGroupForm = this.formBuilder.group({
        name: [medicine_groups.name, Validators.required],
        description: medicine_groups.description,
        id: medicine_groups['id']
      });
    }
    else {
      this.setForm()
    }
  }

  getMedicineGroups() {
    var filters = {}
    if (this.filtersForm) {
      filters['keywords'] = this.filtersForm.value.keywords
    }

    this.MedicineGroupService.getMedicineGroups(filters).subscribe(data => {
      let medicine_groups
      medicine_groups = data
      let array = medicine_groups.map((item, index) => {
        item.index = index + 1
        return item
      })
      this.medicine_groups = new MatTableDataSource(array)
      this.medicine_groups.sort = this.sort
      this.medicine_groups.paginator = this.paginator
    })
  }

  get f() { return this.medicinesGroupForm.controls; }

  onSubmit() {
    this.submitted = true;

    if (this.medicinesGroupForm.invalid) {
      return;
    }
    const fd = new FormData();
    swal({
      title: 'ยืนยันการบันทึก',
      text: "คุณต้องการบันทึกข้อมูลใช่หรือไม่ ?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#36a3f7',
      cancelButtonColor: '#f4516c',
      confirmButtonText: 'ใช่, บันทึกข้อมูล',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.value) {
        fd.append('medicine_group[name]', this.medicinesGroupForm.controls.name.value)
        fd.append('medicine_group[description]', this.medicinesGroupForm.controls.description.value)
        var medicine_group_id = ''
        if (this.medicinesGroupForm.controls.id) {
          medicine_group_id = this.medicinesGroupForm.controls.id.value
        }
        this.MedicineGroupService.submitMedicineGroup(fd, medicine_group_id).subscribe(res => {
          if (res['error']) {
            swal({
              type: 'warning',
              title: 'การบันทึกข้อมูลผิดพลาด',
              showConfirmButton: true,
            })
          }
          else {
            swal({
              type: 'success',
              title: 'บันทึกข้อมูลเรียบร้อยแล้ว',
              showConfirmButton: false,
              timer: 1500
            })
            this.getMedicineGroups();
            this.setForm()
            this.submitted = false
            this.Global.loadScript('assets/script/modal.js');
          }
        })
      }
    })
  }

  delete(id) {
    swal({
      title: 'ยืนยันการลบข้อมูล',
      text: "คุณต้องการลบข้อมูลใช่หรือไม่ ?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#36a3f7',
      cancelButtonColor: '#f4516c',
      confirmButtonText: 'ใช่, ลบข้อมูล',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.value) {
        this.MedicineGroupService.deleteMedicineGroup(id).subscribe(res => {
          swal({
            type: 'success',
            title: 'ลบข้อมูลเรียบร้อยแล้ว',
            showConfirmButton: false,
            timer: 1500
          })
          this.getMedicineGroups();
        })
      }
    })
  }

}
